import './index.css';
import { jsx } from 'react/jsx-runtime';
import { s as styles } from './date-picker-PHuacXwG.js';

const DAYS = [1, 2, 3, 4, 5, 6, 0];
const Weekdays = ({ locale }) => {
    return (jsx("div", { className: styles.weekdays, "data-qa": "date-picker-weekdays", children: DAYS.map((eachWeekday) => (jsx("div", { className: styles.weekday, children: locale.localize.day(eachWeekday, { width: 'short' }) }, `${eachWeekday}`))) }));
};

export { Weekdays };
//# sourceMappingURL=Weekdays.js.map
